import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'orderBy'})
export class OrderByPipe implements PipeTransform {

  public transform(elementArray: any, goodOrder:any ): any {
    const newOrderArray:any = [];

    if (!elementArray) {
        elementArray = [];
    }

    if (!goodOrder) {
        goodOrder = [];
    }

    for (let i = 0; i < goodOrder.length; i++) {
      for(const elementItem of elementArray){
        if (goodOrder[i] === elementItem.idItem) {
          newOrderArray.push(elementItem);
        }
      }
    }


    return newOrderArray;

  }
}
